import React, { PureComponent } from 'react';
import { LinearProgress, Button, FontIcon } from 'react-md';
import EmailerServer from '../../util/emailer-server';
import { trackEvent } from '../../util/analytics';
import './EmailLookup.scss';

export default class EmailLookup extends PureComponent {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    email: '',
    apps: '',

    loading: false,
    found: false,
    step: 1,
    error: false,
  };

  handleChange = state => ({ target: { value } }) =>
    this.setState({
      [state]: value,
    });

  // Apparently, babel is messing up with async arrow functions
  // as class methods. So we use the old way
  async handleSubmit(e) {
    e.preventDefault();

    const { email, apps, step } = this.state;

    this.setState({
      loading: true,
      found: false,
    });

    const postData = {
      email,
      apps,
    };

    try {
      const { ok } = await EmailerServer.send(postData);

      // Grab analytics only on step 1 for discovery
      if (step === 1) {
        trackEvent(
          ok
            ? { category: 'Discovery', action: 'Discovery Success' }
            : { category: 'Discovery', action: 'Discovery Failure - Domain' },
        );
      }

      if (step === 2) {
        trackEvent({
          category: 'Discovery',
          action: 'Discovery Submit App',
        });
      }

      // EmailerServer returns 400 if email is not registered or validation error.
      // We should prob verify using `data` if there is a validation error
      this.setState({
        found: ok,
      });
    } catch (err) {
      trackEvent({
        category: 'Discovery',
        action: 'Discovery Failure - Connection',
      });
      this.setState({
        error: true,
      });
    } finally {
      // Not loading anymore, go to next step
      this.setState(state => ({
        loading: false,
        step: state.step + 1,
      }));
    }
  }

  renderStep1 = () => {
    const { email } = this.state;

    return [
      'In order to review your TrustKit dashboard, please enter your corporate email address below',
      <form key="form" onSubmit={this.handleSubmit} className="inputWrapper">
        <input
          type="email"
          id="email"
          name="email"
          label="Email"
          required
          placeholder="you@example.com"
          onChange={this.handleChange('email')}
          value={email}
        />
        <Button
          flat
          style={{ marginLeft: 10, minWidth: 'unset', padding: '0' }}
          onClick={this.handleSubmit}
          primary
          disabled={email.length < 1}
        >
          <FontIcon className="inputButtonFont">navigate_next</FontIcon>
        </Button>
      </form>,
    ];
  };

  renderStep2 = () => {
    const { apps, found } = this.state;

    if (found) {
      // If emailer server returned 204
      // email exist on our system
      return (
        <div className="result">
          A link for your dashboard has been sent to your email!
        </div>
      );
    }

    return [
      'We were unable to cross link your email address with TrustKit data.',
      <br key="br" />,
      'Please enter your app link or bundle id below',
      <form key="form" onSubmit={this.handleSubmit} className="inputWrapper">
        <textarea
          rows="3"
          required
          placeholder="https://itunes.apple.com/us/app/apple-store/id375380948?mt=8 https://play.google.com/store/apps/details?id=com.datatheorem.android.p1app
          "
          onChange={this.handleChange('apps')}
          value={apps}
        />
        <Button
          flat
          primary
          disabled={apps.length < 1}
          onClick={this.handleSubmit}
        >
          Go
        </Button>
      </form>,
    ];
  };

  renderStep3 = () => (
    <div className="result">
      Thank you. We will get in contact with you shortly.
    </div>
  );

  renderContent = () => {
    const { step, error } = this.state;

    const errorMessage = (
      <div className="result">
        An error occurred. Sorry about that! Try again later.
      </div>
    );

    if (error) {
      return errorMessage;
    }

    if (step === 1) return this.renderStep1();
    if (step === 2) return this.renderStep2();
    if (step === 3) return this.renderStep3();
    return errorMessage;
  };

  render() {
    const { loading } = this.state;

    return (
      <div className="emailLookup">
        {loading && <LinearProgress id="loading" />}
        {!loading && this.renderContent()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EmailLookup/EmailLookup.jsx